export const RADIO_EXAM = [
  {
    title: 'Ya',
    value: 'Ya',
  },
  {
    title: 'Tidak',
    value: 'Tidak',
  },
];

export const RADIO_AGE_GROUP = [
  {
    title: 'Neonatus',
    value: 'NEO',
  },
  {
    title: 'Anak',
    value: 'PEDS',
  },
  {
    title: 'Dewasa',
    value: 'ADULT',
  },
  {
    title: 'Geriatri',
    value: 'GERIATRIC',
  },
];

export const RADIO_PRIORITY = [
  {
    title: 'Elektif',
    value: 'ELECTIVE',
  },
  {
    title: 'Darurat',
    value: 'EMERGENCY',
  },
];

export const RADIO_LOCATION = [
  {
    title: 'RSCM',
    value: 'RSCM',
  },
  {
    title: 'Dharmais',
    value: 'Dharmais',
  },
  {
    title: 'Harapan Kita',
    value: 'Harapan Kita',
  },
  {
    title: 'RSUD Tangerang',
    value: 'RSUD Tangerang',
  },
  {
    title: 'Ruteng',
    value: 'Ruteng',
  },
  {
    title: 'Natuna',
    value: 'Natuna',
  },
  {
    title: 'Fatmawati',
    value: 'Fatmawati',
  },
  {
    title: 'Persahabatan',
    value: 'Persahabatan',
  },
  {
    title: 'RS Jejaring',
    value: 'RS Jejaring',
  },
  {
    title: 'Lainnya',
    value: 'Lainnya',
  },
];

export const RADIO_GENDER = [
  {
    title: 'Laki - Laki',
    value: 'MALE',
  },
  {
    title: 'Perempuan',
    value: 'FEMALE',
  },
];

export const RADIO_EMERGENCY = [
  {
    title: 'Ya',
    value: 'ya',
  },
  {
    title: 'Tidak',
    value: 'tidak',
  },
];

export const RADIO_LOCATION_ICU = [
  {
    title: 'ICU Dewasa',
    value: 'ICU Dewasa',
  },
  {
    title: 'ICU IGD',
    value: 'ICU IGD',
  },
  {
    title: 'ICU RS Lain',
    value: 'ICU RS Lain',
  },
  {
    title: 'HCU',
    value: 'HCU',
  },
  {
    title: 'Lainnya',
    value: 'Lainnya',
  },
];

export const RADIO_LOCATION_RESUS = [
  {
    title: 'IGD',
    value: 'IGD',
  },
  {
    title: 'Ruang Rawat',
    value: 'Ruang Rawat',
  },
  {
    title: 'Lainnya',
    value: 'Lainnya',
  },
];

export const RADIO_LOCATION_PAIN = [
  {
    title: 'ICU',
    value: 'ICU',
  },
  {
    title: 'Wards',
    value: 'Ruang Rawat',
  },
  {
    title: 'Lainnya',
    value: 'Lainnya',
  },
];

export const RADIO_PENILAIAN_GROUP = [
  {
    title: 'Kurang Baik',
    value: 'VERY_BAD',
  },
  {
    title: 'Cukup',
    value: 'NOT_GOOD',
  },
  {
    title: 'Baik',
    value: 'GOOD',
  },
  {
    title: 'Sangat Baik',
    value: 'VERY_GOOD',
  },
];
